export function buildDataRepoFacetTemplate(sourceId: number, esIndex: string) {
    return {
        etl: {
            ds: {
                id: sourceId,
                type: "esindex",
                esindex_name: esIndex,
            },
            name: "Party Support",
            ops: [
                {
                    type: "filter",
                    runon: "esnode",
                    key: "qa_status",
                    "data-type": "str",
                    mode: "blacklist",
                    whitelist: [],
                    blacklist: ["invalid"],
                },
                {
                    type: "pivot",
                    runon: "esnode",
                    row_key: "profile_gender",
                    col_key: "qr_candidate_support",
                    "data-type": "str",
                    mode: "blacklist",
                    transform: {
                        INC: "Congress",
                    },
                    row_whitelist: [],
                    row_blacklist: [],
                    col_whitelist: [],
                    col_blacklist: [],
                    sort_by: "value",
                    sort_order: "desc",
                    include_total_rows: false,
                    include_total_cols: false,
                },
            ],
        },
        decimal_places: 1,
    } as Record<string, unknown>;
}
